const appetites = [{
    "id": 1169804,
    "sectorId": 1169572,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "D&O"
}, {
    "id": 1170423,
    "sectorId": 1169573,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "D&O"
}, {
    "id": 1170482,
    "sectorId": 1169574,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "D&O"
}, {
    "id": 1169796,
    "sectorId": 1169544,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Accountants\/Auditors",
    "productName": "D&O"
}, {
    "id": 1170604,
    "sectorId": 1169548,
    "productId": 1169605,
    "value": 1,
    "sectorName": "Insurance Agents",
    "productName": "D&O"
}, {
    "id": 1170491,
    "sectorId": 1169545,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "D&O"
}, {
    "id": 1170232,
    "sectorId": 1169546,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Architects\/Engineers",
    "productName": "D&O"
}, {
    "id": 1170356,
    "sectorId": 1169547,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "D&O"
}, {
    "id": 1169660,
    "sectorId": 1169549,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "D&O"
}, {
    "id": 1170422,
    "sectorId": 1169598,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "D&O"
}, {
    "id": 1170119,
    "sectorId": 1169599,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "D&O"
}, {
    "id": 1170342,
    "sectorId": 1169600,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "D&O"
}, {
    "id": 1169744,
    "sectorId": 1169567,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "D&O"
}, {
    "id": 1169818,
    "sectorId": 1169568,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "D&O"
}, {
    "id": 1170590,
    "sectorId": 1169569,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "D&O"
}, {
    "id": 1170510,
    "sectorId": 1169570,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "D&O"
}, {
    "id": 1169807,
    "sectorId": 1169592,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Clinical Trials",
    "productName": "D&O"
}, {
    "id": 1170512,
    "sectorId": 1169593,
    "productId": 1169605,
    "value": 1,
    "sectorName": "Dietary Supplements",
    "productName": "D&O"
}, {
    "id": 1170630,
    "sectorId": 1169594,
    "productId": 1169605,
    "value": 3,
    "sectorName": "LS Service Organizations",
    "productName": "D&O"
}, {
    "id": 1169936,
    "sectorId": 1169595,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Medical Devices",
    "productName": "D&O"
}, {
    "id": 1170397,
    "sectorId": 1169596,
    "productId": 1169605,
    "value": 1,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "D&O"
}, {
    "id": 1169712,
    "sectorId": 1169536,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Clean Technology",
    "productName": "D&O"
}, {
    "id": 1170404,
    "sectorId": 1169537,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "D&O"
}, {
    "id": 1169884,
    "sectorId": 1169538,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "D&O"
}, {
    "id": 1170431,
    "sectorId": 1169560,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "D&O"
}, {
    "id": 1170352,
    "sectorId": 1169559,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "D&O"
}, {
    "id": 1169651,
    "sectorId": 1169557,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Commercial Real Estate",
    "productName": "D&O"
}, {
    "id": 1170094,
    "sectorId": 1169563,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Retailers",
    "productName": "D&O"
}, {
    "id": 1170284,
    "sectorId": 1169565,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "D&O"
}, {
    "id": 1169815,
    "sectorId": 1169561,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Hotels",
    "productName": "D&O"
}, {
    "id": 1169886,
    "sectorId": 1169564,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "D&O"
}, {
    "id": 1170389,
    "sectorId": 1169555,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "D&O"
}, {
    "id": 1169821,
    "sectorId": 1169558,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Construction",
    "productName": "D&O"
}, {
    "id": 1170371,
    "sectorId": 1169562,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "D&O"
}, {
    "id": 1169945,
    "sectorId": 1169556,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Aviation",
    "productName": "D&O"
}, {
    "id": 1170497,
    "sectorId": 1169580,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Food",
    "productName": "D&O"
}, {
    "id": 1169678,
    "sectorId": 1169588,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Textiles",
    "productName": "D&O"
}, {
    "id": 1170466,
    "sectorId": 1169579,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "D&O"
}, {
    "id": 1170289,
    "sectorId": 1169590,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "D&O"
}, {
    "id": 1170205,
    "sectorId": 1169585,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "D&O"
}, {
    "id": 1170328,
    "sectorId": 1169586,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "D&O"
}, {
    "id": 1169703,
    "sectorId": 1169577,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Chemical & Allied",
    "productName": "D&O"
}, {
    "id": 1170543,
    "sectorId": 1169587,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Rubber & Plastics",
    "productName": "D&O"
}, {
    "id": 1169702,
    "sectorId": 1169582,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Leather, Stone & Glass",
    "productName": "D&O"
}, {
    "id": 1170109,
    "sectorId": 1169584,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "D&O"
}, {
    "id": 1169897,
    "sectorId": 1169583,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "D&O"
}, {
    "id": 1169644,
    "sectorId": 1169578,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "D&O"
}, {
    "id": 1169843,
    "sectorId": 1169576,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "D&O"
}, {
    "id": 1170103,
    "sectorId": 1169589,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "D&O"
}, {
    "id": 1170383,
    "sectorId": 1169581,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "D&O"
}, {
    "id": 1170537,
    "sectorId": 1169551,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Mining",
    "productName": "D&O"
}, {
    "id": 1170612,
    "sectorId": 1169552,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "D&O"
}, {
    "id": 1169954,
    "sectorId": 1169553,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Power",
    "productName": "D&O"
}, {
    "id": 1170112,
    "sectorId": 1169540,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Broadcasters",
    "productName": "D&O"
}, {
    "id": 1169713,
    "sectorId": 1169541,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Film Production",
    "productName": "D&O"
}, {
    "id": 1170588,
    "sectorId": 1169542,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Theater Production",
    "productName": "D&O"
}, {
    "id": 1170101,
    "sectorId": 1169572,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Asset Management",
    "productName": "EPLI"
}, {
    "id": 1170467,
    "sectorId": 1169573,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "EPLI"
}, {
    "id": 1170207,
    "sectorId": 1169574,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "EPLI"
}, {
    "id": 1169714,
    "sectorId": 1169544,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Accountants\/Auditors",
    "productName": "EPLI"
}, {
    "id": 1169689,
    "sectorId": 1169548,
    "productId": 1169603,
    "value": 1,
    "sectorName": "Insurance Agents",
    "productName": "EPLI"
}, {
    "id": 1169707,
    "sectorId": 1169545,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "EPLI"
}, {
    "id": 1169914,
    "sectorId": 1169546,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Architects\/Engineers",
    "productName": "EPLI"
}, {
    "id": 1170518,
    "sectorId": 1169547,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "EPLI"
}, {
    "id": 1170626,
    "sectorId": 1169549,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "EPLI"
}, {
    "id": 1169667,
    "sectorId": 1169598,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "EPLI"
}, {
    "id": 1169809,
    "sectorId": 1169599,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "EPLI"
}, {
    "id": 1169728,
    "sectorId": 1169600,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "EPLI"
}, {
    "id": 1170024,
    "sectorId": 1169567,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "EPLI"
}, {
    "id": 1170052,
    "sectorId": 1169568,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "EPLI"
}, {
    "id": 1170327,
    "sectorId": 1169569,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "EPLI"
}, {
    "id": 1170002,
    "sectorId": 1169570,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "EPLI"
}, {
    "id": 1170445,
    "sectorId": 1169592,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Clinical Trials",
    "productName": "EPLI"
}, {
    "id": 1170358,
    "sectorId": 1169593,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Dietary Supplements",
    "productName": "EPLI"
}, {
    "id": 1170231,
    "sectorId": 1169594,
    "productId": 1169603,
    "value": 3,
    "sectorName": "LS Service Organizations",
    "productName": "EPLI"
}, {
    "id": 1169823,
    "sectorId": 1169595,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Medical Devices",
    "productName": "EPLI"
}, {
    "id": 1170131,
    "sectorId": 1169596,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "EPLI"
}, {
    "id": 1170048,
    "sectorId": 1169536,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Clean Technology",
    "productName": "EPLI"
}, {
    "id": 1169958,
    "sectorId": 1169537,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "EPLI"
}, {
    "id": 1170629,
    "sectorId": 1169538,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "EPLI"
}, {
    "id": 1170071,
    "sectorId": 1169560,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "EPLI"
}, {
    "id": 1169758,
    "sectorId": 1169559,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "EPLI"
}, {
    "id": 1170050,
    "sectorId": 1169557,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Commercial Real Estate",
    "productName": "EPLI"
}, {
    "id": 1170409,
    "sectorId": 1169563,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Retailers",
    "productName": "EPLI"
}, {
    "id": 1170167,
    "sectorId": 1169565,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "EPLI"
}, {
    "id": 1169861,
    "sectorId": 1169561,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Hotels",
    "productName": "EPLI"
}, {
    "id": 1170082,
    "sectorId": 1169564,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "EPLI"
}, {
    "id": 1170140,
    "sectorId": 1169555,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "EPLI"
}, {
    "id": 1170138,
    "sectorId": 1169558,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Construction",
    "productName": "EPLI"
}, {
    "id": 1170503,
    "sectorId": 1169562,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "EPLI"
}, {
    "id": 1170069,
    "sectorId": 1169556,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Aviation",
    "productName": "EPLI"
}, {
    "id": 1170506,
    "sectorId": 1169580,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Food",
    "productName": "EPLI"
}, {
    "id": 1170601,
    "sectorId": 1169588,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Textiles",
    "productName": "EPLI"
}, {
    "id": 1170647,
    "sectorId": 1169579,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "EPLI"
}, {
    "id": 1170311,
    "sectorId": 1169590,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "EPLI"
}, {
    "id": 1170514,
    "sectorId": 1169585,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "EPLI"
}, {
    "id": 1169830,
    "sectorId": 1169586,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "EPLI"
}, {
    "id": 1170172,
    "sectorId": 1169577,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Chemical & Allied",
    "productName": "EPLI"
}, {
    "id": 1169977,
    "sectorId": 1169587,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Rubber & Plastics",
    "productName": "EPLI"
}, {
    "id": 1169905,
    "sectorId": 1169582,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Leather, Stone & Glass",
    "productName": "EPLI"
}, {
    "id": 1169826,
    "sectorId": 1169584,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "EPLI"
}, {
    "id": 1170170,
    "sectorId": 1169583,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "EPLI"
}, {
    "id": 1170021,
    "sectorId": 1169578,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "EPLI"
}, {
    "id": 1169859,
    "sectorId": 1169576,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "EPLI"
}, {
    "id": 1170256,
    "sectorId": 1169589,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "EPLI"
}, {
    "id": 1170076,
    "sectorId": 1169581,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "EPLI"
}, {
    "id": 1169705,
    "sectorId": 1169551,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Mining",
    "productName": "EPLI"
}, {
    "id": 1170212,
    "sectorId": 1169552,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "EPLI"
}, {
    "id": 1170078,
    "sectorId": 1169553,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Power",
    "productName": "EPLI"
}, {
    "id": 1169723,
    "sectorId": 1169540,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "EPLI"
}, {
    "id": 1170499,
    "sectorId": 1169541,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Film Production",
    "productName": "EPLI"
}, {
    "id": 1169639,
    "sectorId": 1169542,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Theater Production",
    "productName": "EPLI"
}, {
    "id": 1169753,
    "sectorId": 1169572,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169901,
    "sectorId": 1169573,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170123,
    "sectorId": 1169574,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Insurance Companies",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170003,
    "sectorId": 1169544,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Accountants\/Auditors",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169695,
    "sectorId": 1169548,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Insurance Agents",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170278,
    "sectorId": 1169545,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169649,
    "sectorId": 1169546,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170102,
    "sectorId": 1169547,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169760,
    "sectorId": 1169549,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Law Firms",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170106,
    "sectorId": 1169598,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169845,
    "sectorId": 1169599,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170464,
    "sectorId": 1169600,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169895,
    "sectorId": 1169567,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170419,
    "sectorId": 1169568,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169631,
    "sectorId": 1169569,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169908,
    "sectorId": 1169570,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169844,
    "sectorId": 1169592,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170546,
    "sectorId": 1169593,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Dietary Supplements",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170240,
    "sectorId": 1169594,
    "productId": 1169615,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170019,
    "sectorId": 1169595,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170631,
    "sectorId": 1169596,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170211,
    "sectorId": 1169536,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170639,
    "sectorId": 1169537,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170168,
    "sectorId": 1169538,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170444,
    "sectorId": 1169560,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Educational Institutions",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170417,
    "sectorId": 1169559,
    "productId": 1169615,
    "value": 0,
    "sectorName": "Cultural Institutions",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170121,
    "sectorId": 1169557,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Commercial Real Estate",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170197,
    "sectorId": 1169563,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Retailers",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169683,
    "sectorId": 1169565,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170364,
    "sectorId": 1169561,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Hotels",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169872,
    "sectorId": 1169564,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169892,
    "sectorId": 1169555,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170440,
    "sectorId": 1169558,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Construction",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170598,
    "sectorId": 1169562,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169768,
    "sectorId": 1169556,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Aviation",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170547,
    "sectorId": 1169580,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Food",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170097,
    "sectorId": 1169588,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Textiles",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170307,
    "sectorId": 1169579,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170413,
    "sectorId": 1169590,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Wood & Furniture",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169626,
    "sectorId": 1169585,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170374,
    "sectorId": 1169586,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170226,
    "sectorId": 1169577,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Chemical & Allied",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169718,
    "sectorId": 1169587,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Rubber & Plastics",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170461,
    "sectorId": 1169582,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170401,
    "sectorId": 1169584,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170130,
    "sectorId": 1169583,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169942,
    "sectorId": 1169578,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170239,
    "sectorId": 1169576,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Auto Parts",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169834,
    "sectorId": 1169589,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170636,
    "sectorId": 1169581,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169925,
    "sectorId": 1169551,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Mining",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169778,
    "sectorId": 1169552,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Petroleum",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170004,
    "sectorId": 1169553,
    "productId": 1169615,
    "value": 1,
    "sectorName": "Power",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170236,
    "sectorId": 1169540,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Broadcasters",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169737,
    "sectorId": 1169541,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1170566,
    "sectorId": 1169542,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1169996,
    "sectorId": 1169572,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Cyber"
}, {
    "id": 1170340,
    "sectorId": 1169573,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Cyber"
}, {
    "id": 1170220,
    "sectorId": 1169574,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Insurance Companies",
    "productName": "Cyber"
}, {
    "id": 1170277,
    "sectorId": 1169544,
    "productId": 1169602,
    "value": 1,
    "sectorName": "Accountants\/Auditors",
    "productName": "Cyber"
}, {
    "id": 1170343,
    "sectorId": 1169548,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Insurance Agents",
    "productName": "Cyber"
}, {
    "id": 1169687,
    "sectorId": 1169545,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Cyber"
}, {
    "id": 1170449,
    "sectorId": 1169546,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "Cyber"
}, {
    "id": 1170599,
    "sectorId": 1169547,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Cyber"
}, {
    "id": 1169926,
    "sectorId": 1169549,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Cyber"
}, {
    "id": 1169912,
    "sectorId": 1169598,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Cyber"
}, {
    "id": 1170142,
    "sectorId": 1169599,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Cyber"
}, {
    "id": 1170230,
    "sectorId": 1169600,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Cyber"
}, {
    "id": 1170223,
    "sectorId": 1169567,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Cyber"
}, {
    "id": 1170551,
    "sectorId": 1169568,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Cyber"
}, {
    "id": 1169854,
    "sectorId": 1169569,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Network Service Providers",
    "productName": "Cyber"
}, {
    "id": 1169798,
    "sectorId": 1169570,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Cyber"
}, {
    "id": 1170177,
    "sectorId": 1169592,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Cyber"
}, {
    "id": 1170010,
    "sectorId": 1169593,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Dietary Supplements",
    "productName": "Cyber"
}, {
    "id": 1169642,
    "sectorId": 1169594,
    "productId": 1169602,
    "value": 3,
    "sectorName": "LS Service Organizations",
    "productName": "Cyber"
}, {
    "id": 1169724,
    "sectorId": 1169595,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Cyber"
}, {
    "id": 1170085,
    "sectorId": 1169596,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Cyber"
}, {
    "id": 1169944,
    "sectorId": 1169536,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Cyber"
}, {
    "id": 1169832,
    "sectorId": 1169537,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Cyber"
}, {
    "id": 1170433,
    "sectorId": 1169538,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Cyber"
}, {
    "id": 1170298,
    "sectorId": 1169560,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Educational Institutions",
    "productName": "Cyber"
}, {
    "id": 1170539,
    "sectorId": 1169559,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Cyber"
}, {
    "id": 1169715,
    "sectorId": 1169557,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Cyber"
}, {
    "id": 1170260,
    "sectorId": 1169563,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Retailers",
    "productName": "Cyber"
}, {
    "id": 1170323,
    "sectorId": 1169565,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Cyber"
}, {
    "id": 1170305,
    "sectorId": 1169561,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Hotels",
    "productName": "Cyber"
}, {
    "id": 1170091,
    "sectorId": 1169564,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "Cyber"
}, {
    "id": 1170009,
    "sectorId": 1169555,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Cyber"
}, {
    "id": 1170380,
    "sectorId": 1169558,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Construction",
    "productName": "Cyber"
}, {
    "id": 1169972,
    "sectorId": 1169562,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "Cyber"
}, {
    "id": 1170456,
    "sectorId": 1169556,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Aviation",
    "productName": "Cyber"
}, {
    "id": 1169814,
    "sectorId": 1169580,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Food",
    "productName": "Cyber"
}, {
    "id": 1170288,
    "sectorId": 1169588,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Textiles",
    "productName": "Cyber"
}, {
    "id": 1170492,
    "sectorId": 1169579,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Cyber"
}, {
    "id": 1170392,
    "sectorId": 1169590,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "Cyber"
}, {
    "id": 1170276,
    "sectorId": 1169585,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "Cyber"
}, {
    "id": 1170243,
    "sectorId": 1169586,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Cyber"
}, {
    "id": 1169743,
    "sectorId": 1169577,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Chemical & Allied",
    "productName": "Cyber"
}, {
    "id": 1169781,
    "sectorId": 1169587,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "Cyber"
}, {
    "id": 1170435,
    "sectorId": 1169582,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Cyber"
}, {
    "id": 1170561,
    "sectorId": 1169584,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Cyber"
}, {
    "id": 1170242,
    "sectorId": 1169583,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Cyber"
}, {
    "id": 1169810,
    "sectorId": 1169578,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Cyber"
}, {
    "id": 1170083,
    "sectorId": 1169576,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Auto Parts",
    "productName": "Cyber"
}, {
    "id": 1170468,
    "sectorId": 1169589,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Cyber"
}, {
    "id": 1170179,
    "sectorId": 1169581,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Cyber"
}, {
    "id": 1169717,
    "sectorId": 1169551,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Mining",
    "productName": "Cyber"
}, {
    "id": 1169709,
    "sectorId": 1169552,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "Cyber"
}, {
    "id": 1170399,
    "sectorId": 1169553,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Power",
    "productName": "Cyber"
}, {
    "id": 1169856,
    "sectorId": 1169540,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Cyber"
}, {
    "id": 1170504,
    "sectorId": 1169541,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Cyber"
}, {
    "id": 1170369,
    "sectorId": 1169542,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Cyber"
}, {
    "id": 1169923,
    "sectorId": 1169572,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169727,
    "sectorId": 1169573,
    "productId": 1169607,
    "value": 3,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169659,
    "sectorId": 1169574,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170208,
    "sectorId": 1169544,
    "productId": 1169607,
    "value": 3,
    "sectorName": "Accountants\/Auditors",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170267,
    "sectorId": 1169548,
    "productId": 1169607,
    "value": 3,
    "sectorName": "Insurance Agents",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169857,
    "sectorId": 1169545,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170474,
    "sectorId": 1169546,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170287,
    "sectorId": 1169547,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169742,
    "sectorId": 1169549,
    "productId": 1169607,
    "value": 3,
    "sectorName": "Law Firms",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170485,
    "sectorId": 1169598,
    "productId": 1169607,
    "value": 3,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170648,
    "sectorId": 1169599,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170616,
    "sectorId": 1169600,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169970,
    "sectorId": 1169567,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170221,
    "sectorId": 1169568,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170283,
    "sectorId": 1169569,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170361,
    "sectorId": 1169570,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170387,
    "sectorId": 1169592,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170517,
    "sectorId": 1169593,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170377,
    "sectorId": 1169594,
    "productId": 1169607,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170484,
    "sectorId": 1169595,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170402,
    "sectorId": 1169596,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169833,
    "sectorId": 1169536,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170530,
    "sectorId": 1169537,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170500,
    "sectorId": 1169538,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170513,
    "sectorId": 1169560,
    "productId": 1169607,
    "value": 3,
    "sectorName": "Educational Institutions",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169791,
    "sectorId": 1169559,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170606,
    "sectorId": 1169557,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170575,
    "sectorId": 1169563,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Retailers",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170508,
    "sectorId": 1169565,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170237,
    "sectorId": 1169561,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Hotels",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170621,
    "sectorId": 1169564,
    "productId": 1169607,
    "value": 1,
    "sectorName": "Transportation",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170057,
    "sectorId": 1169555,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169994,
    "sectorId": 1169558,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Construction",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169772,
    "sectorId": 1169562,
    "productId": 1169607,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170538,
    "sectorId": 1169556,
    "productId": 1169607,
    "value": 3,
    "sectorName": "Aviation",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170087,
    "sectorId": 1169580,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Food",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169696,
    "sectorId": 1169588,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Textiles",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170182,
    "sectorId": 1169579,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169896,
    "sectorId": 1169590,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170193,
    "sectorId": 1169585,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170350,
    "sectorId": 1169586,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169813,
    "sectorId": 1169577,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Chemical & Allied",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169885,
    "sectorId": 1169587,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Rubber & Plastics",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170620,
    "sectorId": 1169582,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170113,
    "sectorId": 1169584,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170483,
    "sectorId": 1169583,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169842,
    "sectorId": 1169578,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169748,
    "sectorId": 1169576,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170174,
    "sectorId": 1169589,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169785,
    "sectorId": 1169581,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170073,
    "sectorId": 1169551,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Mining",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170310,
    "sectorId": 1169552,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Petroleum",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170584,
    "sectorId": 1169553,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Power",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170522,
    "sectorId": 1169540,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169978,
    "sectorId": 1169541,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1170153,
    "sectorId": 1169542,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1169625,
    "sectorId": 1169572,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Asset Management",
    "productName": "Fiduciary"
}, {
    "id": 1170576,
    "sectorId": 1169573,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Fiduciary"
}, {
    "id": 1170572,
    "sectorId": 1169574,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Fiduciary"
}, {
    "id": 1169893,
    "sectorId": 1169544,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Fiduciary"
}, {
    "id": 1170095,
    "sectorId": 1169548,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Insurance Agents",
    "productName": "Fiduciary"
}, {
    "id": 1169828,
    "sectorId": 1169545,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Fiduciary"
}, {
    "id": 1169947,
    "sectorId": 1169546,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "Fiduciary"
}, {
    "id": 1170501,
    "sectorId": 1169547,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Fiduciary"
}, {
    "id": 1169636,
    "sectorId": 1169549,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Fiduciary"
}, {
    "id": 1170273,
    "sectorId": 1169598,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Fiduciary"
}, {
    "id": 1170509,
    "sectorId": 1169599,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Fiduciary"
}, {
    "id": 1170107,
    "sectorId": 1169600,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Fiduciary"
}, {
    "id": 1170306,
    "sectorId": 1169567,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Fiduciary"
}, {
    "id": 1170611,
    "sectorId": 1169568,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Fiduciary"
}, {
    "id": 1170013,
    "sectorId": 1169569,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Fiduciary"
}, {
    "id": 1169907,
    "sectorId": 1169570,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Fiduciary"
}, {
    "id": 1170146,
    "sectorId": 1169592,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Clinical Trials",
    "productName": "Fiduciary"
}, {
    "id": 1169973,
    "sectorId": 1169593,
    "productId": 1169604,
    "value": 1,
    "sectorName": "Dietary Supplements",
    "productName": "Fiduciary"
}, {
    "id": 1170534,
    "sectorId": 1169594,
    "productId": 1169604,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Fiduciary"
}, {
    "id": 1170378,
    "sectorId": 1169595,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Medical Devices",
    "productName": "Fiduciary"
}, {
    "id": 1169783,
    "sectorId": 1169596,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Fiduciary"
}, {
    "id": 1170194,
    "sectorId": 1169536,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Clean Technology",
    "productName": "Fiduciary"
}, {
    "id": 1170421,
    "sectorId": 1169537,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Fiduciary"
}, {
    "id": 1170007,
    "sectorId": 1169538,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Fiduciary"
}, {
    "id": 1170372,
    "sectorId": 1169560,
    "productId": 1169604,
    "value": 1,
    "sectorName": "Educational Institutions",
    "productName": "Fiduciary"
}, {
    "id": 1170258,
    "sectorId": 1169559,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Fiduciary"
}, {
    "id": 1169991,
    "sectorId": 1169557,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Commercial Real Estate",
    "productName": "Fiduciary"
}, {
    "id": 1170282,
    "sectorId": 1169563,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Retailers",
    "productName": "Fiduciary"
}, {
    "id": 1169873,
    "sectorId": 1169565,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Fiduciary"
}, {
    "id": 1170403,
    "sectorId": 1169561,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Hotels",
    "productName": "Fiduciary"
}, {
    "id": 1170600,
    "sectorId": 1169564,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Transportation",
    "productName": "Fiduciary"
}, {
    "id": 1170528,
    "sectorId": 1169555,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Fiduciary"
}, {
    "id": 1170189,
    "sectorId": 1169558,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Construction",
    "productName": "Fiduciary"
}, {
    "id": 1170570,
    "sectorId": 1169562,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "Fiduciary"
}, {
    "id": 1170619,
    "sectorId": 1169556,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Aviation",
    "productName": "Fiduciary"
}, {
    "id": 1170443,
    "sectorId": 1169580,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Food",
    "productName": "Fiduciary"
}, {
    "id": 1170292,
    "sectorId": 1169588,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Textiles",
    "productName": "Fiduciary"
}, {
    "id": 1170029,
    "sectorId": 1169579,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Fiduciary"
}, {
    "id": 1170110,
    "sectorId": 1169590,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "Fiduciary"
}, {
    "id": 1170552,
    "sectorId": 1169585,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "Fiduciary"
}, {
    "id": 1170159,
    "sectorId": 1169586,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Fiduciary"
}, {
    "id": 1170099,
    "sectorId": 1169577,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Chemical & Allied",
    "productName": "Fiduciary"
}, {
    "id": 1170322,
    "sectorId": 1169587,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Rubber & Plastics",
    "productName": "Fiduciary"
}, {
    "id": 1169825,
    "sectorId": 1169582,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Fiduciary"
}, {
    "id": 1170321,
    "sectorId": 1169584,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Fiduciary"
}, {
    "id": 1170592,
    "sectorId": 1169583,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Fiduciary"
}, {
    "id": 1170290,
    "sectorId": 1169578,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Fiduciary"
}, {
    "id": 1170151,
    "sectorId": 1169576,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "Fiduciary"
}, {
    "id": 1170451,
    "sectorId": 1169589,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Fiduciary"
}, {
    "id": 1169902,
    "sectorId": 1169581,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Fiduciary"
}, {
    "id": 1169971,
    "sectorId": 1169551,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Mining",
    "productName": "Fiduciary"
}, {
    "id": 1170359,
    "sectorId": 1169552,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Petroleum",
    "productName": "Fiduciary"
}, {
    "id": 1170171,
    "sectorId": 1169553,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Power",
    "productName": "Fiduciary"
}, {
    "id": 1170610,
    "sectorId": 1169540,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Fiduciary"
}, {
    "id": 1170560,
    "sectorId": 1169541,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Fiduciary"
}, {
    "id": 1170186,
    "sectorId": 1169542,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Fiduciary"
}, {
    "id": 1170084,
    "sectorId": 1169572,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170074,
    "sectorId": 1169573,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169878,
    "sectorId": 1169574,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169746,
    "sectorId": 1169544,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169653,
    "sectorId": 1169548,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Insurance Agents",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170070,
    "sectorId": 1169545,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170241,
    "sectorId": 1169546,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169935,
    "sectorId": 1169547,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170169,
    "sectorId": 1169549,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170166,
    "sectorId": 1169598,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169780,
    "sectorId": 1169599,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169898,
    "sectorId": 1169600,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170623,
    "sectorId": 1169567,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170044,
    "sectorId": 1169568,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169819,
    "sectorId": 1169569,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169948,
    "sectorId": 1169570,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170363,
    "sectorId": 1169592,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170132,
    "sectorId": 1169593,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170265,
    "sectorId": 1169594,
    "productId": 1169619,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170253,
    "sectorId": 1169595,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170184,
    "sectorId": 1169596,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170015,
    "sectorId": 1169536,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169779,
    "sectorId": 1169537,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170214,
    "sectorId": 1169538,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170295,
    "sectorId": 1169560,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169802,
    "sectorId": 1169559,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170437,
    "sectorId": 1169557,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170200,
    "sectorId": 1169563,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Retailers",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170235,
    "sectorId": 1169565,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170252,
    "sectorId": 1169561,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Hotels",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170203,
    "sectorId": 1169564,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Transportation",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169918,
    "sectorId": 1169555,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170195,
    "sectorId": 1169558,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Construction",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169773,
    "sectorId": 1169562,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Public Entity",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170425,
    "sectorId": 1169556,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Aviation",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169920,
    "sectorId": 1169580,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Food",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169745,
    "sectorId": 1169588,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Textiles",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170158,
    "sectorId": 1169579,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170124,
    "sectorId": 1169590,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170293,
    "sectorId": 1169585,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169630,
    "sectorId": 1169586,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169865,
    "sectorId": 1169577,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Chemical & Allied",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169824,
    "sectorId": 1169587,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Rubber & Plastics",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170329,
    "sectorId": 1169582,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169928,
    "sectorId": 1169584,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169691,
    "sectorId": 1169583,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169922,
    "sectorId": 1169578,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169879,
    "sectorId": 1169576,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170035,
    "sectorId": 1169589,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170602,
    "sectorId": 1169581,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169849,
    "sectorId": 1169551,
    "productId": 1169619,
    "value": 3,
    "sectorName": "Mining",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170454,
    "sectorId": 1169552,
    "productId": 1169619,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170583,
    "sectorId": 1169553,
    "productId": 1169619,
    "value": 3,
    "sectorName": "Power",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169937,
    "sectorId": 1169540,
    "productId": 1169619,
    "value": 3,
    "sectorName": "Broadcasters",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170375,
    "sectorId": 1169541,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1169939,
    "sectorId": 1169542,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1170045,
    "sectorId": 1169572,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Package"
}, {
    "id": 1170206,
    "sectorId": 1169573,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Package"
}, {
    "id": 1170043,
    "sectorId": 1169574,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Package"
}, {
    "id": 1169672,
    "sectorId": 1169544,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Package"
}, {
    "id": 1170090,
    "sectorId": 1169548,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Insurance Agents",
    "productName": "Package"
}, {
    "id": 1170032,
    "sectorId": 1169545,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Package"
}, {
    "id": 1170337,
    "sectorId": 1169546,
    "productId": 1169606,
    "value": 1,
    "sectorName": "Architects\/Engineers",
    "productName": "Package"
}, {
    "id": 1170157,
    "sectorId": 1169547,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Package"
}, {
    "id": 1170149,
    "sectorId": 1169549,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Package"
}, {
    "id": 1170122,
    "sectorId": 1169598,
    "productId": 1169606,
    "value": 0,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Package"
}, {
    "id": 1169894,
    "sectorId": 1169599,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Package"
}, {
    "id": 1170545,
    "sectorId": 1169600,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Package"
}, {
    "id": 1169985,
    "sectorId": 1169567,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Package"
}, {
    "id": 1170526,
    "sectorId": 1169568,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Package"
}, {
    "id": 1170571,
    "sectorId": 1169569,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Package"
}, {
    "id": 1169711,
    "sectorId": 1169570,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Package"
}, {
    "id": 1170257,
    "sectorId": 1169592,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Package"
}, {
    "id": 1170605,
    "sectorId": 1169593,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "Package"
}, {
    "id": 1170400,
    "sectorId": 1169594,
    "productId": 1169606,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Package"
}, {
    "id": 1169934,
    "sectorId": 1169595,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Package"
}, {
    "id": 1170281,
    "sectorId": 1169596,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Package"
}, {
    "id": 1170614,
    "sectorId": 1169536,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Package"
}, {
    "id": 1170040,
    "sectorId": 1169537,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Package"
}, {
    "id": 1170542,
    "sectorId": 1169538,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Package"
}, {
    "id": 1169933,
    "sectorId": 1169560,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Educational Institutions",
    "productName": "Package"
}, {
    "id": 1170213,
    "sectorId": 1169559,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Package"
}, {
    "id": 1170275,
    "sectorId": 1169557,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Commercial Real Estate",
    "productName": "Package"
}, {
    "id": 1169697,
    "sectorId": 1169563,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Retailers",
    "productName": "Package"
}, {
    "id": 1169803,
    "sectorId": 1169565,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Package"
}, {
    "id": 1169786,
    "sectorId": 1169561,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Hotels",
    "productName": "Package"
}, {
    "id": 1170294,
    "sectorId": 1169564,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "Package"
}, {
    "id": 1169770,
    "sectorId": 1169555,
    "productId": 1169606,
    "value": 1,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Package"
}, {
    "id": 1170202,
    "sectorId": 1169558,
    "productId": 1169606,
    "value": 1,
    "sectorName": "Construction",
    "productName": "Package"
}, {
    "id": 1170529,
    "sectorId": 1169562,
    "productId": 1169606,
    "value": 1,
    "sectorName": "Public Entity",
    "productName": "Package"
}, {
    "id": 1169984,
    "sectorId": 1169556,
    "productId": 1169606,
    "value": 1,
    "sectorName": "Aviation",
    "productName": "Package"
}, {
    "id": 1170023,
    "sectorId": 1169580,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Food",
    "productName": "Package"
}, {
    "id": 1170093,
    "sectorId": 1169588,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Textiles",
    "productName": "Package"
}, {
    "id": 1170204,
    "sectorId": 1169579,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Package"
}, {
    "id": 1170391,
    "sectorId": 1169590,
    "productId": 1169606,
    "value": 1,
    "sectorName": "Wood & Furniture",
    "productName": "Package"
}, {
    "id": 1170210,
    "sectorId": 1169585,
    "productId": 1169606,
    "value": 1,
    "sectorName": "Paper Products",
    "productName": "Package"
}, {
    "id": 1170309,
    "sectorId": 1169586,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Printing & Publishing",
    "productName": "Package"
}, {
    "id": 1170268,
    "sectorId": 1169577,
    "productId": 1169606,
    "value": 1,
    "sectorName": "Chemical & Allied",
    "productName": "Package"
}, {
    "id": 1170274,
    "sectorId": 1169587,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "Package"
}, {
    "id": 1169956,
    "sectorId": 1169582,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Package"
}, {
    "id": 1170056,
    "sectorId": 1169584,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Package"
}, {
    "id": 1170325,
    "sectorId": 1169583,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Package"
}, {
    "id": 1170217,
    "sectorId": 1169578,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Package"
}, {
    "id": 1169628,
    "sectorId": 1169576,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "Package"
}, {
    "id": 1169927,
    "sectorId": 1169589,
    "productId": 1169606,
    "value": 3,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Package"
}, {
    "id": 1170556,
    "sectorId": 1169581,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Package"
}, {
    "id": 1170381,
    "sectorId": 1169551,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Mining",
    "productName": "Package"
}, {
    "id": 1170544,
    "sectorId": 1169552,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Petroleum",
    "productName": "Package"
}, {
    "id": 1170089,
    "sectorId": 1169553,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Power",
    "productName": "Package"
}, {
    "id": 1169990,
    "sectorId": 1169540,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Package"
}, {
    "id": 1170255,
    "sectorId": 1169541,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Package"
}, {
    "id": 1170280,
    "sectorId": 1169542,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Package"
}, {
    "id": 1170418,
    "sectorId": 1169572,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Workers Comp"
}, {
    "id": 1169641,
    "sectorId": 1169573,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Workers Comp"
}, {
    "id": 1170126,
    "sectorId": 1169574,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Workers Comp"
}, {
    "id": 1170312,
    "sectorId": 1169544,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Workers Comp"
}, {
    "id": 1169655,
    "sectorId": 1169548,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Insurance Agents",
    "productName": "Workers Comp"
}, {
    "id": 1170368,
    "sectorId": 1169545,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Workers Comp"
}, {
    "id": 1170152,
    "sectorId": 1169546,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Architects\/Engineers",
    "productName": "Workers Comp"
}, {
    "id": 1170594,
    "sectorId": 1169547,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Workers Comp"
}, {
    "id": 1170086,
    "sectorId": 1169549,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Workers Comp"
}, {
    "id": 1170105,
    "sectorId": 1169598,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Workers Comp"
}, {
    "id": 1170120,
    "sectorId": 1169599,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Long Term Care Facilities",
    "productName": "Workers Comp"
}, {
    "id": 1170301,
    "sectorId": 1169600,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Outpatient Medical",
    "productName": "Workers Comp"
}, {
    "id": 1169699,
    "sectorId": 1169567,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Workers Comp"
}, {
    "id": 1170478,
    "sectorId": 1169568,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Workers Comp"
}, {
    "id": 1169722,
    "sectorId": 1169569,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Workers Comp"
}, {
    "id": 1170147,
    "sectorId": 1169570,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Workers Comp"
}, {
    "id": 1170502,
    "sectorId": 1169592,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Workers Comp"
}, {
    "id": 1170264,
    "sectorId": 1169593,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Dietary Supplements",
    "productName": "Workers Comp"
}, {
    "id": 1169635,
    "sectorId": 1169594,
    "productId": 1169612,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Workers Comp"
}, {
    "id": 1169967,
    "sectorId": 1169595,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Medical Devices",
    "productName": "Workers Comp"
}, {
    "id": 1170420,
    "sectorId": 1169596,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Workers Comp"
}, {
    "id": 1170463,
    "sectorId": 1169536,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Workers Comp"
}, {
    "id": 1169690,
    "sectorId": 1169537,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Workers Comp"
}, {
    "id": 1169716,
    "sectorId": 1169538,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Workers Comp"
}, {
    "id": 1169806,
    "sectorId": 1169560,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Educational Institutions",
    "productName": "Workers Comp"
}, {
    "id": 1170634,
    "sectorId": 1169559,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Workers Comp"
}, {
    "id": 1170261,
    "sectorId": 1169557,
    "productId": 1169612,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Workers Comp"
}, {
    "id": 1170018,
    "sectorId": 1169563,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Retailers",
    "productName": "Workers Comp"
}, {
    "id": 1170617,
    "sectorId": 1169565,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Wholesalers",
    "productName": "Workers Comp"
}, {
    "id": 1170150,
    "sectorId": 1169561,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Hotels",
    "productName": "Workers Comp"
}, {
    "id": 1169647,
    "sectorId": 1169564,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Transportation",
    "productName": "Workers Comp"
}, {
    "id": 1170081,
    "sectorId": 1169555,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Workers Comp"
}, {
    "id": 1170353,
    "sectorId": 1169558,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Construction",
    "productName": "Workers Comp"
}, {
    "id": 1170609,
    "sectorId": 1169562,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Public Entity",
    "productName": "Workers Comp"
}, {
    "id": 1170033,
    "sectorId": 1169556,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Aviation",
    "productName": "Workers Comp"
}, {
    "id": 1170303,
    "sectorId": 1169580,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Food",
    "productName": "Workers Comp"
}, {
    "id": 1170316,
    "sectorId": 1169588,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Textiles",
    "productName": "Workers Comp"
}, {
    "id": 1170248,
    "sectorId": 1169579,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Fabricated Products",
    "productName": "Workers Comp"
}, {
    "id": 1170125,
    "sectorId": 1169590,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Wood & Furniture",
    "productName": "Workers Comp"
}, {
    "id": 1170137,
    "sectorId": 1169585,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Paper Products",
    "productName": "Workers Comp"
}, {
    "id": 1170473,
    "sectorId": 1169586,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Printing & Publishing",
    "productName": "Workers Comp"
}, {
    "id": 1170026,
    "sectorId": 1169577,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Chemical & Allied",
    "productName": "Workers Comp"
}, {
    "id": 1170229,
    "sectorId": 1169587,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "Workers Comp"
}, {
    "id": 1170550,
    "sectorId": 1169582,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Workers Comp"
}, {
    "id": 1170006,
    "sectorId": 1169584,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Metal Workers",
    "productName": "Workers Comp"
}, {
    "id": 1170051,
    "sectorId": 1169583,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Machinery",
    "productName": "Workers Comp"
}, {
    "id": 1170183,
    "sectorId": 1169578,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Electrical Equipment",
    "productName": "Workers Comp"
}, {
    "id": 1169946,
    "sectorId": 1169576,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Auto Parts",
    "productName": "Workers Comp"
}, {
    "id": 1170080,
    "sectorId": 1169589,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Workers Comp"
}, {
    "id": 1170355,
    "sectorId": 1169581,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Instruments",
    "productName": "Workers Comp"
}, {
    "id": 1169993,
    "sectorId": 1169551,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Mining",
    "productName": "Workers Comp"
}, {
    "id": 1170565,
    "sectorId": 1169552,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "Workers Comp"
}, {
    "id": 1170505,
    "sectorId": 1169553,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Power",
    "productName": "Workers Comp"
}, {
    "id": 1170128,
    "sectorId": 1169540,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Broadcasters",
    "productName": "Workers Comp"
}, {
    "id": 1170064,
    "sectorId": 1169541,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Film Production",
    "productName": "Workers Comp"
}, {
    "id": 1170460,
    "sectorId": 1169542,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Theater Production",
    "productName": "Workers Comp"
}, {
    "id": 1170198,
    "sectorId": 1169572,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Auto"
}, {
    "id": 1170129,
    "sectorId": 1169573,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Auto"
}, {
    "id": 1170511,
    "sectorId": 1169574,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Auto"
}, {
    "id": 1169776,
    "sectorId": 1169544,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Auto"
}, {
    "id": 1169910,
    "sectorId": 1169548,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Insurance Agents",
    "productName": "Auto"
}, {
    "id": 1170063,
    "sectorId": 1169545,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Auto"
}, {
    "id": 1169794,
    "sectorId": 1169546,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Architects\/Engineers",
    "productName": "Auto"
}, {
    "id": 1169829,
    "sectorId": 1169547,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Auto"
}, {
    "id": 1170000,
    "sectorId": 1169549,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Auto"
}, {
    "id": 1170427,
    "sectorId": 1169598,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Auto"
}, {
    "id": 1170224,
    "sectorId": 1169599,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Long Term Care Facilities",
    "productName": "Auto"
}, {
    "id": 1170141,
    "sectorId": 1169600,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Outpatient Medical",
    "productName": "Auto"
}, {
    "id": 1170245,
    "sectorId": 1169567,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Computer Software Developers",
    "productName": "Auto"
}, {
    "id": 1170031,
    "sectorId": 1169568,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Auto"
}, {
    "id": 1169680,
    "sectorId": 1169569,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Auto"
}, {
    "id": 1169747,
    "sectorId": 1169570,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Auto"
}, {
    "id": 1170593,
    "sectorId": 1169592,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Auto"
}, {
    "id": 1169763,
    "sectorId": 1169593,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "Auto"
}, {
    "id": 1169657,
    "sectorId": 1169594,
    "productId": 1169614,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Auto"
}, {
    "id": 1169731,
    "sectorId": 1169595,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Auto"
}, {
    "id": 1170453,
    "sectorId": 1169596,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Auto"
}, {
    "id": 1170331,
    "sectorId": 1169536,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Clean Technology",
    "productName": "Auto"
}, {
    "id": 1170386,
    "sectorId": 1169537,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Federal Contractors",
    "productName": "Auto"
}, {
    "id": 1170393,
    "sectorId": 1169538,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Auto"
}, {
    "id": 1169754,
    "sectorId": 1169560,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Educational Institutions",
    "productName": "Auto"
}, {
    "id": 1170597,
    "sectorId": 1169559,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Auto"
}, {
    "id": 1170487,
    "sectorId": 1169557,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Auto"
}, {
    "id": 1170554,
    "sectorId": 1169563,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Retailers",
    "productName": "Auto"
}, {
    "id": 1170111,
    "sectorId": 1169565,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Wholesalers",
    "productName": "Auto"
}, {
    "id": 1170563,
    "sectorId": 1169561,
    "productId": 1169614,
    "value": 1,
    "sectorName": "Hotels",
    "productName": "Auto"
}, {
    "id": 1169698,
    "sectorId": 1169564,
    "productId": 1169614,
    "value": 1,
    "sectorName": "Transportation",
    "productName": "Auto"
}, {
    "id": 1170049,
    "sectorId": 1169555,
    "productId": 1169614,
    "value": 1,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Auto"
}, {
    "id": 1170494,
    "sectorId": 1169558,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Construction",
    "productName": "Auto"
}, {
    "id": 1169706,
    "sectorId": 1169562,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "Auto"
}, {
    "id": 1169755,
    "sectorId": 1169556,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Aviation",
    "productName": "Auto"
}, {
    "id": 1170334,
    "sectorId": 1169580,
    "productId": 1169614,
    "value": 2,
    "sectorName": "Food",
    "productName": "Auto"
}, {
    "id": 1170028,
    "sectorId": 1169588,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Textiles",
    "productName": "Auto"
}, {
    "id": 1169721,
    "sectorId": 1169579,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Fabricated Products",
    "productName": "Auto"
}, {
    "id": 1169903,
    "sectorId": 1169590,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Wood & Furniture",
    "productName": "Auto"
}, {
    "id": 1170486,
    "sectorId": 1169585,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Paper Products",
    "productName": "Auto"
}, {
    "id": 1169909,
    "sectorId": 1169586,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Printing & Publishing",
    "productName": "Auto"
}, {
    "id": 1170628,
    "sectorId": 1169577,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Chemical & Allied",
    "productName": "Auto"
}, {
    "id": 1170039,
    "sectorId": 1169587,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "Auto"
}, {
    "id": 1170406,
    "sectorId": 1169582,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Auto"
}, {
    "id": 1169999,
    "sectorId": 1169584,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Metal Workers",
    "productName": "Auto"
}, {
    "id": 1170519,
    "sectorId": 1169583,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Machinery",
    "productName": "Auto"
}, {
    "id": 1169860,
    "sectorId": 1169578,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Electrical Equipment",
    "productName": "Auto"
}, {
    "id": 1169982,
    "sectorId": 1169576,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Auto Parts",
    "productName": "Auto"
}, {
    "id": 1169855,
    "sectorId": 1169589,
    "productId": 1169614,
    "value": 1,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Auto"
}, {
    "id": 1169774,
    "sectorId": 1169581,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Instruments",
    "productName": "Auto"
}, {
    "id": 1170250,
    "sectorId": 1169551,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Mining",
    "productName": "Auto"
}, {
    "id": 1169940,
    "sectorId": 1169552,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "Auto"
}, {
    "id": 1170411,
    "sectorId": 1169553,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Power",
    "productName": "Auto"
}, {
    "id": 1169852,
    "sectorId": 1169540,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Broadcasters",
    "productName": "Auto"
}, {
    "id": 1170408,
    "sectorId": 1169541,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Film Production",
    "productName": "Auto"
}, {
    "id": 1169915,
    "sectorId": 1169542,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Theater Production",
    "productName": "Auto"
}, {
    "id": 1170457,
    "sectorId": 1169572,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169874,
    "sectorId": 1169573,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170270,
    "sectorId": 1169574,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169734,
    "sectorId": 1169544,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169694,
    "sectorId": 1169548,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Insurance Agents",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170525,
    "sectorId": 1169545,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170455,
    "sectorId": 1169546,
    "productId": 1169618,
    "value": 1,
    "sectorName": "Architects\/Engineers",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170162,
    "sectorId": 1169547,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170115,
    "sectorId": 1169549,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169980,
    "sectorId": 1169598,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169622,
    "sectorId": 1169599,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169904,
    "sectorId": 1169600,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169848,
    "sectorId": 1169567,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169759,
    "sectorId": 1169568,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169911,
    "sectorId": 1169569,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169900,
    "sectorId": 1169570,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169700,
    "sectorId": 1169592,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169871,
    "sectorId": 1169593,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Dietary Supplements",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170041,
    "sectorId": 1169594,
    "productId": 1169618,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170416,
    "sectorId": 1169595,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170332,
    "sectorId": 1169596,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170259,
    "sectorId": 1169536,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Clean Technology",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169862,
    "sectorId": 1169537,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Federal Contractors",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169799,
    "sectorId": 1169538,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170540,
    "sectorId": 1169560,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Educational Institutions",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170448,
    "sectorId": 1169559,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169640,
    "sectorId": 1169557,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170067,
    "sectorId": 1169563,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Retailers",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170012,
    "sectorId": 1169565,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Wholesalers",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170573,
    "sectorId": 1169561,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Hotels",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169784,
    "sectorId": 1169564,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170394,
    "sectorId": 1169555,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170585,
    "sectorId": 1169558,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Construction",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169919,
    "sectorId": 1169562,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170524,
    "sectorId": 1169556,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Aviation",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169963,
    "sectorId": 1169580,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Food",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169741,
    "sectorId": 1169588,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Textiles",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170017,
    "sectorId": 1169579,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169756,
    "sectorId": 1169590,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Wood & Furniture",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170272,
    "sectorId": 1169585,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Paper Products",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169979,
    "sectorId": 1169586,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169917,
    "sectorId": 1169577,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Chemical & Allied",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170326,
    "sectorId": 1169587,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170185,
    "sectorId": 1169582,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170008,
    "sectorId": 1169584,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Metal Workers",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170635,
    "sectorId": 1169583,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Machinery",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170382,
    "sectorId": 1169578,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Electrical Equipment",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170458,
    "sectorId": 1169576,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Auto Parts",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170336,
    "sectorId": 1169589,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169839,
    "sectorId": 1169581,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Instruments",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170398,
    "sectorId": 1169551,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Mining",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170072,
    "sectorId": 1169552,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170034,
    "sectorId": 1169553,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Power",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170037,
    "sectorId": 1169540,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1169975,
    "sectorId": 1169541,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170065,
    "sectorId": 1169542,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1170532,
    "sectorId": 1169572,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Environmental"
}, {
    "id": 1170175,
    "sectorId": 1169573,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Environmental"
}, {
    "id": 1170030,
    "sectorId": 1169574,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Environmental"
}, {
    "id": 1170092,
    "sectorId": 1169544,
    "productId": 1169608,
    "value": 0,
    "sectorName": "Accountants\/Auditors",
    "productName": "Environmental"
}, {
    "id": 1169733,
    "sectorId": 1169548,
    "productId": 1169608,
    "value": 0,
    "sectorName": "Insurance Agents",
    "productName": "Environmental"
}, {
    "id": 1170490,
    "sectorId": 1169545,
    "productId": 1169608,
    "value": 0,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Environmental"
}, {
    "id": 1169725,
    "sectorId": 1169546,
    "productId": 1169608,
    "value": 0,
    "sectorName": "Architects\/Engineers",
    "productName": "Environmental"
}, {
    "id": 1169654,
    "sectorId": 1169547,
    "productId": 1169608,
    "value": 0,
    "sectorName": "Business Consultants",
    "productName": "Environmental"
}, {
    "id": 1170269,
    "sectorId": 1169549,
    "productId": 1169608,
    "value": 0,
    "sectorName": "Law Firms",
    "productName": "Environmental"
}, {
    "id": 1170438,
    "sectorId": 1169598,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Environmental"
}, {
    "id": 1169788,
    "sectorId": 1169599,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Environmental"
}, {
    "id": 1169720,
    "sectorId": 1169600,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Environmental"
}, {
    "id": 1170520,
    "sectorId": 1169567,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Environmental"
}, {
    "id": 1169851,
    "sectorId": 1169568,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Environmental"
}, {
    "id": 1169719,
    "sectorId": 1169569,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Environmental"
}, {
    "id": 1169771,
    "sectorId": 1169570,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Environmental"
}, {
    "id": 1169682,
    "sectorId": 1169592,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Environmental"
}, {
    "id": 1170632,
    "sectorId": 1169593,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "Environmental"
}, {
    "id": 1170390,
    "sectorId": 1169594,
    "productId": 1169608,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Environmental"
}, {
    "id": 1169921,
    "sectorId": 1169595,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Environmental"
}, {
    "id": 1170104,
    "sectorId": 1169596,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Environmental"
}, {
    "id": 1170249,
    "sectorId": 1169536,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Environmental"
}, {
    "id": 1169913,
    "sectorId": 1169537,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Environmental"
}, {
    "id": 1170228,
    "sectorId": 1169538,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Environmental"
}, {
    "id": 1169941,
    "sectorId": 1169560,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "Environmental"
}, {
    "id": 1169986,
    "sectorId": 1169559,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Environmental"
}, {
    "id": 1170618,
    "sectorId": 1169557,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Environmental"
}, {
    "id": 1169836,
    "sectorId": 1169563,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Retailers",
    "productName": "Environmental"
}, {
    "id": 1169668,
    "sectorId": 1169565,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Environmental"
}, {
    "id": 1169846,
    "sectorId": 1169561,
    "productId": 1169608,
    "value": 3,
    "sectorName": "Hotels",
    "productName": "Environmental"
}, {
    "id": 1169751,
    "sectorId": 1169564,
    "productId": 1169608,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "Environmental"
}, {
    "id": 1170164,
    "sectorId": 1169555,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Environmental"
}, {
    "id": 1169632,
    "sectorId": 1169558,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Construction",
    "productName": "Environmental"
}, {
    "id": 1170025,
    "sectorId": 1169562,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Public Entity",
    "productName": "Environmental"
}, {
    "id": 1170627,
    "sectorId": 1169556,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Aviation",
    "productName": "Environmental"
}, {
    "id": 1170429,
    "sectorId": 1169580,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Food",
    "productName": "Environmental"
}, {
    "id": 1170414,
    "sectorId": 1169588,
    "productId": 1169608,
    "value": 3,
    "sectorName": "Textiles",
    "productName": "Environmental"
}, {
    "id": 1169924,
    "sectorId": 1169579,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Environmental"
}, {
    "id": 1169880,
    "sectorId": 1169590,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "Environmental"
}, {
    "id": 1170027,
    "sectorId": 1169585,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "Environmental"
}, {
    "id": 1170053,
    "sectorId": 1169586,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Environmental"
}, {
    "id": 1170569,
    "sectorId": 1169577,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Chemical & Allied",
    "productName": "Environmental"
}, {
    "id": 1170354,
    "sectorId": 1169587,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Rubber & Plastics",
    "productName": "Environmental"
}, {
    "id": 1169708,
    "sectorId": 1169582,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Environmental"
}, {
    "id": 1170005,
    "sectorId": 1169584,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Environmental"
}, {
    "id": 1170173,
    "sectorId": 1169583,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Environmental"
}, {
    "id": 1170558,
    "sectorId": 1169578,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Environmental"
}, {
    "id": 1170567,
    "sectorId": 1169576,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "Environmental"
}, {
    "id": 1170388,
    "sectorId": 1169589,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Environmental"
}, {
    "id": 1170271,
    "sectorId": 1169581,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Environmental"
}, {
    "id": 1169775,
    "sectorId": 1169551,
    "productId": 1169608,
    "value": 3,
    "sectorName": "Mining",
    "productName": "Environmental"
}, {
    "id": 1169674,
    "sectorId": 1169552,
    "productId": 1169608,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "Environmental"
}, {
    "id": 1170222,
    "sectorId": 1169553,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Power",
    "productName": "Environmental"
}, {
    "id": 1170351,
    "sectorId": 1169540,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Environmental"
}, {
    "id": 1170148,
    "sectorId": 1169541,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Environmental"
}, {
    "id": 1169764,
    "sectorId": 1169542,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Environmental"
}, {
    "id": 1170339,
    "sectorId": 1169572,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "General Liability"
}, {
    "id": 1170415,
    "sectorId": 1169573,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "General Liability"
}, {
    "id": 1169835,
    "sectorId": 1169574,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "General Liability"
}, {
    "id": 1170291,
    "sectorId": 1169544,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "General Liability"
}, {
    "id": 1170410,
    "sectorId": 1169548,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Insurance Agents",
    "productName": "General Liability"
}, {
    "id": 1169931,
    "sectorId": 1169545,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "General Liability"
}, {
    "id": 1170244,
    "sectorId": 1169546,
    "productId": 1169613,
    "value": 1,
    "sectorName": "Architects\/Engineers",
    "productName": "General Liability"
}, {
    "id": 1169817,
    "sectorId": 1169547,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "General Liability"
}, {
    "id": 1169882,
    "sectorId": 1169549,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "General Liability"
}, {
    "id": 1170046,
    "sectorId": 1169598,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "General Liability"
}, {
    "id": 1170161,
    "sectorId": 1169599,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "General Liability"
}, {
    "id": 1169867,
    "sectorId": 1169600,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "General Liability"
}, {
    "id": 1170127,
    "sectorId": 1169567,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "General Liability"
}, {
    "id": 1170477,
    "sectorId": 1169568,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "General Liability"
}, {
    "id": 1169634,
    "sectorId": 1169569,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "General Liability"
}, {
    "id": 1169643,
    "sectorId": 1169570,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "General Liability"
}, {
    "id": 1170489,
    "sectorId": 1169592,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "General Liability"
}, {
    "id": 1170176,
    "sectorId": 1169593,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Dietary Supplements",
    "productName": "General Liability"
}, {
    "id": 1169789,
    "sectorId": 1169594,
    "productId": 1169613,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "General Liability"
}, {
    "id": 1170384,
    "sectorId": 1169595,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "General Liability"
}, {
    "id": 1169729,
    "sectorId": 1169596,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "General Liability"
}, {
    "id": 1170541,
    "sectorId": 1169536,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Clean Technology",
    "productName": "General Liability"
}, {
    "id": 1170536,
    "sectorId": 1169537,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "General Liability"
}, {
    "id": 1169983,
    "sectorId": 1169538,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "General Liability"
}, {
    "id": 1169663,
    "sectorId": 1169560,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Educational Institutions",
    "productName": "General Liability"
}, {
    "id": 1169701,
    "sectorId": 1169559,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "General Liability"
}, {
    "id": 1170227,
    "sectorId": 1169557,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Commercial Real Estate",
    "productName": "General Liability"
}, {
    "id": 1170297,
    "sectorId": 1169563,
    "productId": 1169613,
    "value": 1,
    "sectorName": "Retailers",
    "productName": "General Liability"
}, {
    "id": 1170638,
    "sectorId": 1169565,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "General Liability"
}, {
    "id": 1170452,
    "sectorId": 1169561,
    "productId": 1169613,
    "value": 1,
    "sectorName": "Hotels",
    "productName": "General Liability"
}, {
    "id": 1170330,
    "sectorId": 1169564,
    "productId": 1169613,
    "value": 1,
    "sectorName": "Transportation",
    "productName": "General Liability"
}, {
    "id": 1170533,
    "sectorId": 1169555,
    "productId": 1169613,
    "value": 1,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "General Liability"
}, {
    "id": 1169957,
    "sectorId": 1169558,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Construction",
    "productName": "General Liability"
}, {
    "id": 1170615,
    "sectorId": 1169562,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "General Liability"
}, {
    "id": 1169949,
    "sectorId": 1169556,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Aviation",
    "productName": "General Liability"
}, {
    "id": 1170396,
    "sectorId": 1169580,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Food",
    "productName": "General Liability"
}, {
    "id": 1169890,
    "sectorId": 1169588,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Textiles",
    "productName": "General Liability"
}, {
    "id": 1169889,
    "sectorId": 1169579,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Fabricated Products",
    "productName": "General Liability"
}, {
    "id": 1170108,
    "sectorId": 1169590,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Wood & Furniture",
    "productName": "General Liability"
}, {
    "id": 1170042,
    "sectorId": 1169585,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Paper Products",
    "productName": "General Liability"
}, {
    "id": 1169646,
    "sectorId": 1169586,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Printing & Publishing",
    "productName": "General Liability"
}, {
    "id": 1170531,
    "sectorId": 1169577,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Chemical & Allied",
    "productName": "General Liability"
}, {
    "id": 1170498,
    "sectorId": 1169587,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "General Liability"
}, {
    "id": 1169730,
    "sectorId": 1169582,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Leather, Stone & Glass",
    "productName": "General Liability"
}, {
    "id": 1169858,
    "sectorId": 1169584,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Metal Workers",
    "productName": "General Liability"
}, {
    "id": 1169782,
    "sectorId": 1169583,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Machinery",
    "productName": "General Liability"
}, {
    "id": 1170181,
    "sectorId": 1169578,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Electrical Equipment",
    "productName": "General Liability"
}, {
    "id": 1170324,
    "sectorId": 1169576,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Auto Parts",
    "productName": "General Liability"
}, {
    "id": 1169962,
    "sectorId": 1169589,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "General Liability"
}, {
    "id": 1169992,
    "sectorId": 1169581,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Instruments",
    "productName": "General Liability"
}, {
    "id": 1170555,
    "sectorId": 1169551,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Mining",
    "productName": "General Liability"
}, {
    "id": 1170154,
    "sectorId": 1169552,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "General Liability"
}, {
    "id": 1170133,
    "sectorId": 1169553,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Power",
    "productName": "General Liability"
}, {
    "id": 1169827,
    "sectorId": 1169540,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Broadcasters",
    "productName": "General Liability"
}, {
    "id": 1170059,
    "sectorId": 1169541,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Film Production",
    "productName": "General Liability"
}, {
    "id": 1170216,
    "sectorId": 1169542,
    "productId": 1169613,
    "value": 3,
    "sectorName": "Theater Production",
    "productName": "General Liability"
}, {
    "id": 1169808,
    "sectorId": 1169572,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Property"
}, {
    "id": 1170096,
    "sectorId": 1169573,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Property"
}, {
    "id": 1169899,
    "sectorId": 1169574,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Property"
}, {
    "id": 1169645,
    "sectorId": 1169544,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Property"
}, {
    "id": 1170470,
    "sectorId": 1169548,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Insurance Agents",
    "productName": "Property"
}, {
    "id": 1170516,
    "sectorId": 1169545,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Property"
}, {
    "id": 1170079,
    "sectorId": 1169546,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "Property"
}, {
    "id": 1169800,
    "sectorId": 1169547,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Property"
}, {
    "id": 1170058,
    "sectorId": 1169549,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Property"
}, {
    "id": 1170370,
    "sectorId": 1169598,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Property"
}, {
    "id": 1170447,
    "sectorId": 1169599,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Property"
}, {
    "id": 1169797,
    "sectorId": 1169600,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Property"
}, {
    "id": 1169652,
    "sectorId": 1169567,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Property"
}, {
    "id": 1170188,
    "sectorId": 1169568,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Property"
}, {
    "id": 1169951,
    "sectorId": 1169569,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Property"
}, {
    "id": 1169735,
    "sectorId": 1169570,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Property"
}, {
    "id": 1170062,
    "sectorId": 1169592,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Property"
}, {
    "id": 1170246,
    "sectorId": 1169593,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "Property"
}, {
    "id": 1170318,
    "sectorId": 1169594,
    "productId": 1169616,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Property"
}, {
    "id": 1169692,
    "sectorId": 1169595,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Property"
}, {
    "id": 1169974,
    "sectorId": 1169596,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Property"
}, {
    "id": 1169968,
    "sectorId": 1169536,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Property"
}, {
    "id": 1169959,
    "sectorId": 1169537,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Property"
}, {
    "id": 1170254,
    "sectorId": 1169538,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Property"
}, {
    "id": 1169805,
    "sectorId": 1169560,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "Property"
}, {
    "id": 1169732,
    "sectorId": 1169559,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Property"
}, {
    "id": 1170346,
    "sectorId": 1169557,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Commercial Real Estate",
    "productName": "Property"
}, {
    "id": 1170428,
    "sectorId": 1169563,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Retailers",
    "productName": "Property"
}, {
    "id": 1170434,
    "sectorId": 1169565,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Property"
}, {
    "id": 1170535,
    "sectorId": 1169561,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Hotels",
    "productName": "Property"
}, {
    "id": 1170577,
    "sectorId": 1169564,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "Property"
}, {
    "id": 1170644,
    "sectorId": 1169555,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Property"
}, {
    "id": 1170209,
    "sectorId": 1169558,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Construction",
    "productName": "Property"
}, {
    "id": 1169761,
    "sectorId": 1169562,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Public Entity",
    "productName": "Property"
}, {
    "id": 1170557,
    "sectorId": 1169556,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Aviation",
    "productName": "Property"
}, {
    "id": 1169930,
    "sectorId": 1169580,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Food",
    "productName": "Property"
}, {
    "id": 1169988,
    "sectorId": 1169588,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Textiles",
    "productName": "Property"
}, {
    "id": 1169685,
    "sectorId": 1169579,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Property"
}, {
    "id": 1169906,
    "sectorId": 1169590,
    "productId": 1169616,
    "value": 1,
    "sectorName": "Wood & Furniture",
    "productName": "Property"
}, {
    "id": 1169869,
    "sectorId": 1169585,
    "productId": 1169616,
    "value": 1,
    "sectorName": "Paper Products",
    "productName": "Property"
}, {
    "id": 1169875,
    "sectorId": 1169586,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Printing & Publishing",
    "productName": "Property"
}, {
    "id": 1170348,
    "sectorId": 1169577,
    "productId": 1169616,
    "value": 1,
    "sectorName": "Chemical & Allied",
    "productName": "Property"
}, {
    "id": 1170596,
    "sectorId": 1169587,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "Property"
}, {
    "id": 1170589,
    "sectorId": 1169582,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Property"
}, {
    "id": 1170642,
    "sectorId": 1169584,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Property"
}, {
    "id": 1170385,
    "sectorId": 1169583,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Property"
}, {
    "id": 1169868,
    "sectorId": 1169578,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Property"
}, {
    "id": 1169790,
    "sectorId": 1169576,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "Property"
}, {
    "id": 1170036,
    "sectorId": 1169589,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Property"
}, {
    "id": 1170191,
    "sectorId": 1169581,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Property"
}, {
    "id": 1169847,
    "sectorId": 1169551,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Mining",
    "productName": "Property"
}, {
    "id": 1170279,
    "sectorId": 1169552,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Petroleum",
    "productName": "Property"
}, {
    "id": 1169795,
    "sectorId": 1169553,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Power",
    "productName": "Property"
}, {
    "id": 1169981,
    "sectorId": 1169540,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Property"
}, {
    "id": 1170066,
    "sectorId": 1169541,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Property"
}, {
    "id": 1170165,
    "sectorId": 1169542,
    "productId": 1169616,
    "value": 3,
    "sectorName": "Theater Production",
    "productName": "Property"
}, {
    "id": 1170116,
    "sectorId": 1169572,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169787,
    "sectorId": 1169573,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170446,
    "sectorId": 1169574,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170196,
    "sectorId": 1169544,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170553,
    "sectorId": 1169548,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Insurance Agents",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169792,
    "sectorId": 1169545,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170581,
    "sectorId": 1169546,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170349,
    "sectorId": 1169547,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170595,
    "sectorId": 1169549,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170038,
    "sectorId": 1169598,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169998,
    "sectorId": 1169599,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169664,
    "sectorId": 1169600,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170637,
    "sectorId": 1169567,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169693,
    "sectorId": 1169568,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169929,
    "sectorId": 1169569,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170523,
    "sectorId": 1169570,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169853,
    "sectorId": 1169592,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170472,
    "sectorId": 1169593,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170441,
    "sectorId": 1169594,
    "productId": 1169611,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170219,
    "sectorId": 1169595,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170315,
    "sectorId": 1169596,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169831,
    "sectorId": 1169536,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169676,
    "sectorId": 1169537,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169965,
    "sectorId": 1169538,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170055,
    "sectorId": 1169560,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170118,
    "sectorId": 1169559,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170308,
    "sectorId": 1169557,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170586,
    "sectorId": 1169563,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Retailers",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169762,
    "sectorId": 1169565,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169987,
    "sectorId": 1169561,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Hotels",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170450,
    "sectorId": 1169564,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Transportation",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170379,
    "sectorId": 1169555,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170564,
    "sectorId": 1169558,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Construction",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170014,
    "sectorId": 1169562,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Public Entity",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169766,
    "sectorId": 1169556,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Aviation",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169952,
    "sectorId": 1169580,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Food",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170465,
    "sectorId": 1169588,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Textiles",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170300,
    "sectorId": 1169579,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169726,
    "sectorId": 1169590,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Wood & Furniture",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170234,
    "sectorId": 1169585,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Paper Products",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169801,
    "sectorId": 1169586,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Printing & Publishing",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169750,
    "sectorId": 1169577,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Chemical & Allied",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170199,
    "sectorId": 1169587,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170493,
    "sectorId": 1169582,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170365,
    "sectorId": 1169584,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169677,
    "sectorId": 1169583,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169629,
    "sectorId": 1169578,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170578,
    "sectorId": 1169576,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170643,
    "sectorId": 1169589,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169841,
    "sectorId": 1169581,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170521,
    "sectorId": 1169551,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Mining",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170373,
    "sectorId": 1169552,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169932,
    "sectorId": 1169553,
    "productId": 1169611,
    "value": 3,
    "sectorName": "Power",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169816,
    "sectorId": 1169540,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169960,
    "sectorId": 1169541,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Equipment Breakdown"
}, {
    "id": 1170559,
    "sectorId": 1169542,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Equipment Breakdown"
}, {
    "id": 1169989,
    "sectorId": 1169572,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Inland Marine"
}, {
    "id": 1170160,
    "sectorId": 1169573,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Inland Marine"
}, {
    "id": 1169877,
    "sectorId": 1169574,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Inland Marine"
}, {
    "id": 1170145,
    "sectorId": 1169544,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Inland Marine"
}, {
    "id": 1169811,
    "sectorId": 1169548,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Insurance Agents",
    "productName": "Inland Marine"
}, {
    "id": 1169673,
    "sectorId": 1169545,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Inland Marine"
}, {
    "id": 1170247,
    "sectorId": 1169546,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "Inland Marine"
}, {
    "id": 1169765,
    "sectorId": 1169547,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Inland Marine"
}, {
    "id": 1169658,
    "sectorId": 1169549,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Inland Marine"
}, {
    "id": 1169943,
    "sectorId": 1169598,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Inland Marine"
}, {
    "id": 1170603,
    "sectorId": 1169599,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Inland Marine"
}, {
    "id": 1170233,
    "sectorId": 1169600,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Inland Marine"
}, {
    "id": 1169793,
    "sectorId": 1169567,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Inland Marine"
}, {
    "id": 1169704,
    "sectorId": 1169568,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Inland Marine"
}, {
    "id": 1170587,
    "sectorId": 1169569,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Inland Marine"
}, {
    "id": 1170020,
    "sectorId": 1169570,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Inland Marine"
}, {
    "id": 1169686,
    "sectorId": 1169592,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Inland Marine"
}, {
    "id": 1169863,
    "sectorId": 1169593,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "Inland Marine"
}, {
    "id": 1170333,
    "sectorId": 1169594,
    "productId": 1169610,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Inland Marine"
}, {
    "id": 1169670,
    "sectorId": 1169595,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Inland Marine"
}, {
    "id": 1169710,
    "sectorId": 1169596,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Inland Marine"
}, {
    "id": 1170580,
    "sectorId": 1169536,
    "productId": 1169610,
    "value": 3,
    "sectorName": "Clean Technology",
    "productName": "Inland Marine"
}, {
    "id": 1170488,
    "sectorId": 1169537,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Inland Marine"
}, {
    "id": 1169916,
    "sectorId": 1169538,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Inland Marine"
}, {
    "id": 1169837,
    "sectorId": 1169560,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "Inland Marine"
}, {
    "id": 1170075,
    "sectorId": 1169559,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Inland Marine"
}, {
    "id": 1169648,
    "sectorId": 1169557,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Inland Marine"
}, {
    "id": 1170479,
    "sectorId": 1169563,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Retailers",
    "productName": "Inland Marine"
}, {
    "id": 1169671,
    "sectorId": 1169565,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Inland Marine"
}, {
    "id": 1170625,
    "sectorId": 1169561,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Hotels",
    "productName": "Inland Marine"
}, {
    "id": 1169749,
    "sectorId": 1169564,
    "productId": 1169610,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "Inland Marine"
}, {
    "id": 1169840,
    "sectorId": 1169555,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Inland Marine"
}, {
    "id": 1170527,
    "sectorId": 1169558,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Construction",
    "productName": "Inland Marine"
}, {
    "id": 1169638,
    "sectorId": 1169562,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Public Entity",
    "productName": "Inland Marine"
}, {
    "id": 1169662,
    "sectorId": 1169556,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Aviation",
    "productName": "Inland Marine"
}, {
    "id": 1170640,
    "sectorId": 1169580,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Food",
    "productName": "Inland Marine"
}, {
    "id": 1169938,
    "sectorId": 1169588,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Textiles",
    "productName": "Inland Marine"
}, {
    "id": 1170344,
    "sectorId": 1169579,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Inland Marine"
}, {
    "id": 1170313,
    "sectorId": 1169590,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "Inland Marine"
}, {
    "id": 1170299,
    "sectorId": 1169585,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "Inland Marine"
}, {
    "id": 1170568,
    "sectorId": 1169586,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Inland Marine"
}, {
    "id": 1170238,
    "sectorId": 1169577,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Chemical & Allied",
    "productName": "Inland Marine"
}, {
    "id": 1170426,
    "sectorId": 1169587,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Rubber & Plastics",
    "productName": "Inland Marine"
}, {
    "id": 1169637,
    "sectorId": 1169582,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Inland Marine"
}, {
    "id": 1170335,
    "sectorId": 1169584,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Inland Marine"
}, {
    "id": 1170263,
    "sectorId": 1169583,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Inland Marine"
}, {
    "id": 1170376,
    "sectorId": 1169578,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Inland Marine"
}, {
    "id": 1169777,
    "sectorId": 1169576,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "Inland Marine"
}, {
    "id": 1170022,
    "sectorId": 1169589,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Inland Marine"
}, {
    "id": 1170412,
    "sectorId": 1169581,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Inland Marine"
}, {
    "id": 1169820,
    "sectorId": 1169551,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Mining",
    "productName": "Inland Marine"
}, {
    "id": 1170163,
    "sectorId": 1169552,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Petroleum",
    "productName": "Inland Marine"
}, {
    "id": 1170436,
    "sectorId": 1169553,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Power",
    "productName": "Inland Marine"
}, {
    "id": 1170302,
    "sectorId": 1169540,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Inland Marine"
}, {
    "id": 1170459,
    "sectorId": 1169541,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Inland Marine"
}, {
    "id": 1170579,
    "sectorId": 1169542,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Inland Marine"
}, {
    "id": 1170495,
    "sectorId": 1169572,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Asset Management",
    "productName": "Ocean Cargo"
}, {
    "id": 1170633,
    "sectorId": 1169573,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Ocean Cargo"
}, {
    "id": 1170314,
    "sectorId": 1169574,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Insurance Companies",
    "productName": "Ocean Cargo"
}, {
    "id": 1170366,
    "sectorId": 1169544,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Accountants\/Auditors",
    "productName": "Ocean Cargo"
}, {
    "id": 1169740,
    "sectorId": 1169548,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Insurance Agents",
    "productName": "Ocean Cargo"
}, {
    "id": 1169757,
    "sectorId": 1169545,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Ocean Cargo"
}, {
    "id": 1170218,
    "sectorId": 1169546,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Architects\/Engineers",
    "productName": "Ocean Cargo"
}, {
    "id": 1170077,
    "sectorId": 1169547,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Business Consultants",
    "productName": "Ocean Cargo"
}, {
    "id": 1170098,
    "sectorId": 1169549,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Law Firms",
    "productName": "Ocean Cargo"
}, {
    "id": 1170061,
    "sectorId": 1169598,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Ocean Cargo"
}, {
    "id": 1169666,
    "sectorId": 1169599,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Long Term Care Facilities",
    "productName": "Ocean Cargo"
}, {
    "id": 1170319,
    "sectorId": 1169600,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Outpatient Medical",
    "productName": "Ocean Cargo"
}, {
    "id": 1170117,
    "sectorId": 1169567,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Computer Software Developers",
    "productName": "Ocean Cargo"
}, {
    "id": 1169866,
    "sectorId": 1169568,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Ocean Cargo"
}, {
    "id": 1169864,
    "sectorId": 1169569,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Ocean Cargo"
}, {
    "id": 1170047,
    "sectorId": 1169570,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Technology Service Providers",
    "productName": "Ocean Cargo"
}, {
    "id": 1170462,
    "sectorId": 1169592,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Ocean Cargo"
}, {
    "id": 1169739,
    "sectorId": 1169593,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Dietary Supplements",
    "productName": "Ocean Cargo"
}, {
    "id": 1169950,
    "sectorId": 1169594,
    "productId": 1169609,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Ocean Cargo"
}, {
    "id": 1170338,
    "sectorId": 1169595,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Ocean Cargo"
}, {
    "id": 1170285,
    "sectorId": 1169596,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Ocean Cargo"
}, {
    "id": 1169870,
    "sectorId": 1169536,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Clean Technology",
    "productName": "Ocean Cargo"
}, {
    "id": 1169888,
    "sectorId": 1169537,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Federal Contractors",
    "productName": "Ocean Cargo"
}, {
    "id": 1170496,
    "sectorId": 1169538,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Private Equity",
    "productName": "Ocean Cargo"
}, {
    "id": 1170317,
    "sectorId": 1169560,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "Ocean Cargo"
}, {
    "id": 1170549,
    "sectorId": 1169559,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Ocean Cargo"
}, {
    "id": 1170341,
    "sectorId": 1169557,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Commercial Real Estate",
    "productName": "Ocean Cargo"
}, {
    "id": 1169738,
    "sectorId": 1169563,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Retailers",
    "productName": "Ocean Cargo"
}, {
    "id": 1170144,
    "sectorId": 1169565,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Ocean Cargo"
}, {
    "id": 1169883,
    "sectorId": 1169561,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Hotels",
    "productName": "Ocean Cargo"
}, {
    "id": 1170367,
    "sectorId": 1169564,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Transportation",
    "productName": "Ocean Cargo"
}, {
    "id": 1169684,
    "sectorId": 1169555,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Ocean Cargo"
}, {
    "id": 1169665,
    "sectorId": 1169558,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Construction",
    "productName": "Ocean Cargo"
}, {
    "id": 1169752,
    "sectorId": 1169562,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Public Entity",
    "productName": "Ocean Cargo"
}, {
    "id": 1169769,
    "sectorId": 1169556,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Aviation",
    "productName": "Ocean Cargo"
}, {
    "id": 1169681,
    "sectorId": 1169580,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Food",
    "productName": "Ocean Cargo"
}, {
    "id": 1169669,
    "sectorId": 1169588,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Textiles",
    "productName": "Ocean Cargo"
}, {
    "id": 1170192,
    "sectorId": 1169579,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Ocean Cargo"
}, {
    "id": 1170475,
    "sectorId": 1169590,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "Ocean Cargo"
}, {
    "id": 1169838,
    "sectorId": 1169585,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "Ocean Cargo"
}, {
    "id": 1169876,
    "sectorId": 1169586,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Ocean Cargo"
}, {
    "id": 1170347,
    "sectorId": 1169577,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Chemical & Allied",
    "productName": "Ocean Cargo"
}, {
    "id": 1170641,
    "sectorId": 1169587,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "Ocean Cargo"
}, {
    "id": 1170645,
    "sectorId": 1169582,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Ocean Cargo"
}, {
    "id": 1170471,
    "sectorId": 1169584,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "Ocean Cargo"
}, {
    "id": 1170100,
    "sectorId": 1169583,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Ocean Cargo"
}, {
    "id": 1170607,
    "sectorId": 1169578,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Ocean Cargo"
}, {
    "id": 1169955,
    "sectorId": 1169576,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Auto Parts",
    "productName": "Ocean Cargo"
}, {
    "id": 1170054,
    "sectorId": 1169589,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Ocean Cargo"
}, {
    "id": 1169997,
    "sectorId": 1169581,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Ocean Cargo"
}, {
    "id": 1170481,
    "sectorId": 1169551,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Mining",
    "productName": "Ocean Cargo"
}, {
    "id": 1170582,
    "sectorId": 1169552,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "Ocean Cargo"
}, {
    "id": 1170011,
    "sectorId": 1169553,
    "productId": 1169609,
    "value": 3,
    "sectorName": "Power",
    "productName": "Ocean Cargo"
}, {
    "id": 1169966,
    "sectorId": 1169540,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Ocean Cargo"
}, {
    "id": 1170613,
    "sectorId": 1169541,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Ocean Cargo"
}, {
    "id": 1170480,
    "sectorId": 1169542,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Ocean Cargo"
}, {
    "id": 1170469,
    "sectorId": 1169572,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "Multinational"
}, {
    "id": 1170562,
    "sectorId": 1169573,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "Multinational"
}, {
    "id": 1170646,
    "sectorId": 1169574,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "Multinational"
}, {
    "id": 1169633,
    "sectorId": 1169544,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "Multinational"
}, {
    "id": 1170432,
    "sectorId": 1169548,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Insurance Agents",
    "productName": "Multinational"
}, {
    "id": 1170215,
    "sectorId": 1169545,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "Multinational"
}, {
    "id": 1170357,
    "sectorId": 1169546,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "Multinational"
}, {
    "id": 1170114,
    "sectorId": 1169547,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "Multinational"
}, {
    "id": 1170430,
    "sectorId": 1169549,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "Multinational"
}, {
    "id": 1169850,
    "sectorId": 1169598,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "Multinational"
}, {
    "id": 1169736,
    "sectorId": 1169599,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "Multinational"
}, {
    "id": 1170360,
    "sectorId": 1169600,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "Multinational"
}, {
    "id": 1169812,
    "sectorId": 1169567,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "Multinational"
}, {
    "id": 1169976,
    "sectorId": 1169568,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "Multinational"
}, {
    "id": 1170201,
    "sectorId": 1169569,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "Multinational"
}, {
    "id": 1170060,
    "sectorId": 1169570,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "Multinational"
}, {
    "id": 1169675,
    "sectorId": 1169592,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "Multinational"
}, {
    "id": 1170262,
    "sectorId": 1169593,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "Multinational"
}, {
    "id": 1170574,
    "sectorId": 1169594,
    "productId": 1169617,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "Multinational"
}, {
    "id": 1170286,
    "sectorId": 1169595,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "Multinational"
}, {
    "id": 1169767,
    "sectorId": 1169596,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "Multinational"
}, {
    "id": 1170178,
    "sectorId": 1169536,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "Multinational"
}, {
    "id": 1170439,
    "sectorId": 1169537,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "Multinational"
}, {
    "id": 1170591,
    "sectorId": 1169538,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "Multinational"
}, {
    "id": 1169995,
    "sectorId": 1169560,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "Multinational"
}, {
    "id": 1169624,
    "sectorId": 1169559,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "Multinational"
}, {
    "id": 1169688,
    "sectorId": 1169557,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "Multinational"
}, {
    "id": 1169881,
    "sectorId": 1169563,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Retailers",
    "productName": "Multinational"
}, {
    "id": 1170251,
    "sectorId": 1169565,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "Multinational"
}, {
    "id": 1170135,
    "sectorId": 1169561,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Hotels",
    "productName": "Multinational"
}, {
    "id": 1170001,
    "sectorId": 1169564,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Transportation",
    "productName": "Multinational"
}, {
    "id": 1170136,
    "sectorId": 1169555,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "Multinational"
}, {
    "id": 1170608,
    "sectorId": 1169558,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Construction",
    "productName": "Multinational"
}, {
    "id": 1169627,
    "sectorId": 1169562,
    "productId": 1169617,
    "value": 0,
    "sectorName": "Public Entity",
    "productName": "Multinational"
}, {
    "id": 1169650,
    "sectorId": 1169556,
    "productId": 1169617,
    "value": 0,
    "sectorName": "Aviation",
    "productName": "Multinational"
}, {
    "id": 1170187,
    "sectorId": 1169580,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Food",
    "productName": "Multinational"
}, {
    "id": 1170088,
    "sectorId": 1169588,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Textiles",
    "productName": "Multinational"
}, {
    "id": 1170190,
    "sectorId": 1169579,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "Multinational"
}, {
    "id": 1169656,
    "sectorId": 1169590,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Wood & Furniture",
    "productName": "Multinational"
}, {
    "id": 1170139,
    "sectorId": 1169585,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Paper Products",
    "productName": "Multinational"
}, {
    "id": 1169661,
    "sectorId": 1169586,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Printing & Publishing",
    "productName": "Multinational"
}, {
    "id": 1169679,
    "sectorId": 1169577,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Chemical & Allied",
    "productName": "Multinational"
}, {
    "id": 1169822,
    "sectorId": 1169587,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Rubber & Plastics",
    "productName": "Multinational"
}, {
    "id": 1170624,
    "sectorId": 1169582,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Leather, Stone & Glass",
    "productName": "Multinational"
}, {
    "id": 1170515,
    "sectorId": 1169584,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Metal Workers",
    "productName": "Multinational"
}, {
    "id": 1169969,
    "sectorId": 1169583,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "Multinational"
}, {
    "id": 1170424,
    "sectorId": 1169578,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "Multinational"
}, {
    "id": 1170362,
    "sectorId": 1169576,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Auto Parts",
    "productName": "Multinational"
}, {
    "id": 1170407,
    "sectorId": 1169589,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "Multinational"
}, {
    "id": 1169891,
    "sectorId": 1169581,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "Multinational"
}, {
    "id": 1169887,
    "sectorId": 1169551,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Mining",
    "productName": "Multinational"
}, {
    "id": 1170134,
    "sectorId": 1169552,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "Multinational"
}, {
    "id": 1169961,
    "sectorId": 1169553,
    "productId": 1169617,
    "value": 3,
    "sectorName": "Power",
    "productName": "Multinational"
}, {
    "id": 1170143,
    "sectorId": 1169540,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "Multinational"
}, {
    "id": 1170156,
    "sectorId": 1169541,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "Multinational"
}, {
    "id": 1170395,
    "sectorId": 1169542,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "Multinational"
}, {
    "id": 1206509,
    "sectorId": 1169572,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Asset Management",
    "productName": "A&H"
}, {
    "id": 1206522,
    "sectorId": 1169573,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Banks\/Lending Institutions",
    "productName": "A&H"
}, {
    "id": 1206524,
    "sectorId": 1169574,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Insurance Companies",
    "productName": "A&H"
}, {
    "id": 1206526,
    "sectorId": 1169544,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Accountants\/Auditors",
    "productName": "A&H"
}, {
    "id": 1206527,
    "sectorId": 1169548,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Insurance Agents",
    "productName": "A&H"
}, {
    "id": 1206533,
    "sectorId": 1169545,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Advertising\/PR Agencies",
    "productName": "A&H"
}, {
    "id": 1206535,
    "sectorId": 1169546,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Architects\/Engineers",
    "productName": "A&H"
}, {
    "id": 1206534,
    "sectorId": 1169547,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Business Consultants",
    "productName": "A&H"
}, {
    "id": 1206537,
    "sectorId": 1169549,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Law Firms",
    "productName": "A&H"
}, {
    "id": 1206538,
    "sectorId": 1169598,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Hospitals & Healthcare Systems",
    "productName": "A&H"
}, {
    "id": 1206539,
    "sectorId": 1169599,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Long Term Care Facilities",
    "productName": "A&H"
}, {
    "id": 1206543,
    "sectorId": 1169600,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Outpatient Medical",
    "productName": "A&H"
}, {
    "id": 1206545,
    "sectorId": 1169567,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Computer Software Developers",
    "productName": "A&H"
}, {
    "id": 1206546,
    "sectorId": 1169568,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Hardware Manufacturers",
    "productName": "A&H"
}, {
    "id": 1206547,
    "sectorId": 1169569,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Network Service Providers",
    "productName": "A&H"
}, {
    "id": 1206548,
    "sectorId": 1169570,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Technology Service Providers",
    "productName": "A&H"
}, {
    "id": 1206549,
    "sectorId": 1169592,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Clinical Trials",
    "productName": "A&H"
}, {
    "id": 1206550,
    "sectorId": 1169593,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Dietary Supplements",
    "productName": "A&H"
}, {
    "id": 1206544,
    "sectorId": 1169594,
    "productId": 1206511,
    "value": 4,
    "sectorName": "LS Service Organizations",
    "productName": "A&H"
}, {
    "id": 1206552,
    "sectorId": 1169595,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Medical Devices",
    "productName": "A&H"
}, {
    "id": 1206553,
    "sectorId": 1169596,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Pharmaceutical\/Biotechnology",
    "productName": "A&H"
}, {
    "id": 1206554,
    "sectorId": 1169536,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Clean Technology",
    "productName": "A&H"
}, {
    "id": 1206555,
    "sectorId": 1169537,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Federal Contractors",
    "productName": "A&H"
}, {
    "id": 1206556,
    "sectorId": 1169538,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Private Equity",
    "productName": "A&H"
}, {
    "id": 1206557,
    "sectorId": 1169560,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Educational Institutions",
    "productName": "A&H"
}, {
    "id": 1206558,
    "sectorId": 1169559,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Cultural Institutions",
    "productName": "A&H"
}, {
    "id": 1206551,
    "sectorId": 1169557,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Commercial Real Estate",
    "productName": "A&H"
}, {
    "id": 1206562,
    "sectorId": 1169563,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Retailers",
    "productName": "A&H"
}, {
    "id": 1206563,
    "sectorId": 1169565,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Wholesalers",
    "productName": "A&H"
}, {
    "id": 1206564,
    "sectorId": 1169561,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Hotels",
    "productName": "A&H"
}, {
    "id": 1206565,
    "sectorId": 1169564,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Transportation",
    "productName": "A&H"
}, {
    "id": 1206566,
    "sectorId": 1169555,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Amusement Parks & Clubs",
    "productName": "A&H"
}, {
    "id": 1206567,
    "sectorId": 1169558,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Construction",
    "productName": "A&H"
}, {
    "id": 1206561,
    "sectorId": 1169562,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Public Entity",
    "productName": "A&H"
}, {
    "id": 1206573,
    "sectorId": 1169556,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Aviation",
    "productName": "A&H"
}, {
    "id": 1206574,
    "sectorId": 1169580,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Food",
    "productName": "A&H"
}, {
    "id": 1206575,
    "sectorId": 1169588,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Textiles",
    "productName": "A&H"
}, {
    "id": 1206576,
    "sectorId": 1169579,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Fabricated Products",
    "productName": "A&H"
}, {
    "id": 1206577,
    "sectorId": 1169590,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Wood & Furniture",
    "productName": "A&H"
}, {
    "id": 1206578,
    "sectorId": 1169585,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Paper Products",
    "productName": "A&H"
}, {
    "id": 1206572,
    "sectorId": 1169577,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Chemical & Allied",
    "productName": "A&H"
}, {
    "id": 1206580,
    "sectorId": 1169587,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Rubber & Plastics",
    "productName": "A&H"
}, {
    "id": 1206579,
    "sectorId": 1169582,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Leather, Stone & Glass",
    "productName": "A&H"
}, {
    "id": 1206583,
    "sectorId": 1169584,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Metal Workers",
    "productName": "A&H"
}, {
    "id": 1206593,
    "sectorId": 1169583,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Machinery",
    "productName": "A&H"
}, {
    "id": 1206594,
    "sectorId": 1169578,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Electrical Equipment",
    "productName": "A&H"
}, {
    "id": 1206595,
    "sectorId": 1169576,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Auto Parts",
    "productName": "A&H"
}, {
    "id": 1206596,
    "sectorId": 1169589,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Transport Equip (non Auto)",
    "productName": "A&H"
}, {
    "id": 1206597,
    "sectorId": 1169581,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Instruments",
    "productName": "A&H"
}, {
    "id": 1206585,
    "sectorId": 1169551,
    "productId": 1206511,
    "value": 1,
    "sectorName": "Mining",
    "productName": "A&H"
}, {
    "id": 1206586,
    "sectorId": 1169552,
    "productId": 1206511,
    "value": 3,
    "sectorName": "Petroleum",
    "productName": "A&H"
}, {
    "id": 1206587,
    "sectorId": 1169553,
    "productId": 1206511,
    "value": 3,
    "sectorName": "Power",
    "productName": "A&H"
}, {
    "id": 1206588,
    "sectorId": 1169540,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Broadcasters",
    "productName": "A&H"
}, {
    "id": 1206589,
    "sectorId": 1169541,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Film Production",
    "productName": "A&H"
}, {
    "id": 1206590,
    "sectorId": 1169542,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Theater Production",
    "productName": "A&H"
}, {
    "id": 1255004,
    "sectorId": 1254995,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Managed Care",
    "productName": "A&H"
}, {
    "id": 1255023,
    "sectorId": 1254995,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Managed Care",
    "productName": "Auto"
}, {
    "id": 1255017,
    "sectorId": 1254995,
    "productId": 1169602,
    "value": 3,
    "sectorName": "Managed Care",
    "productName": "Cyber"
}, {
    "id": 1255014,
    "sectorId": 1254995,
    "productId": 1169605,
    "value": 3,
    "sectorName": "Managed Care",
    "productName": "D&O"
}, {
    "id": 1255025,
    "sectorId": 1254995,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Managed Care",
    "productName": "Environmental"
}, {
    "id": 1255015,
    "sectorId": 1254995,
    "productId": 1169603,
    "value": 3,
    "sectorName": "Managed Care",
    "productName": "EPLI"
}, {
    "id": 1255028,
    "sectorId": 1254995,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Managed Care",
    "productName": "Equipment Breakdown"
}, {
    "id": 1255018,
    "sectorId": 1254995,
    "productId": 1169607,
    "value": 3,
    "sectorName": "Managed Care",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1255019,
    "sectorId": 1254995,
    "productId": 1169604,
    "value": 3,
    "sectorName": "Managed Care",
    "productName": "Fiduciary"
}, {
    "id": 1255026,
    "sectorId": 1254995,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Managed Care",
    "productName": "General Liability"
}, {
    "id": 1255029,
    "sectorId": 1254995,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Managed Care",
    "productName": "Inland Marine"
}, {
    "id": 1255020,
    "sectorId": 1254995,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Managed Care",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1255012,
    "sectorId": 1254995,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Managed Care",
    "productName": "Multinational"
}, {
    "id": 1255030,
    "sectorId": 1254995,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Managed Care",
    "productName": "Ocean Cargo"
}, {
    "id": 1255021,
    "sectorId": 1254995,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Managed Care",
    "productName": "Package"
}, {
    "id": 1255016,
    "sectorId": 1254995,
    "productId": 1169615,
    "value": 3,
    "sectorName": "Managed Care",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1255027,
    "sectorId": 1254995,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Managed Care",
    "productName": "Property"
}, {
    "id": 1255024,
    "sectorId": 1254995,
    "productId": 1169618,
    "value": 3,
    "sectorName": "Managed Care",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1255022,
    "sectorId": 1254995,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Managed Care",
    "productName": "Workers Comp"
}, {
    "id": 1249862,
    "sectorId": 1249858,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Equipment Breakdown"
}, {
    "id": 1249871,
    "sectorId": 1249858,
    "productId": 1169612,
    "value": 3,
    "sectorName": "Marine Facilities",
    "productName": "Workers Comp"
}, {
    "id": 1249872,
    "sectorId": 1249858,
    "productId": 1169614,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Auto"
}, {
    "id": 1249873,
    "sectorId": 1249858,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1249874,
    "sectorId": 1249858,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Environmental"
}, {
    "id": 1249875,
    "sectorId": 1249858,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "General Liability"
}, {
    "id": 1249876,
    "sectorId": 1249858,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Property"
}, {
    "id": 1249877,
    "sectorId": 1249858,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Inland Marine"
}, {
    "id": 1249878,
    "sectorId": 1249858,
    "productId": 1169609,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Ocean Cargo"
}, {
    "id": 1249879,
    "sectorId": 1249858,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Multinational"
}, {
    "id": 1249880,
    "sectorId": 1249858,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "A&H"
}, {
    "id": 1249863,
    "sectorId": 1249858,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "D&O"
}, {
    "id": 1249864,
    "sectorId": 1249858,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "EPLI"
}, {
    "id": 1249865,
    "sectorId": 1249858,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1249866,
    "sectorId": 1249858,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Cyber"
}, {
    "id": 1249867,
    "sectorId": 1249858,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1249868,
    "sectorId": 1249858,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Fiduciary"
}, {
    "id": 1249869,
    "sectorId": 1249858,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1249870,
    "sectorId": 1249858,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Marine Facilities",
    "productName": "Package"
}, {
    "id": 1255009,
    "sectorId": 1254996,
    "productId": 1206511,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "A&H"
}, {
    "id": 1255091,
    "sectorId": 1254996,
    "productId": 1169614,
    "value": 3,
    "sectorName": "Physician Groups",
    "productName": "Auto"
}, {
    "id": 1255096,
    "sectorId": 1254996,
    "productId": 1169602,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Cyber"
}, {
    "id": 1255099,
    "sectorId": 1254996,
    "productId": 1169605,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "D&O"
}, {
    "id": 1255089,
    "sectorId": 1254996,
    "productId": 1169608,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Environmental"
}, {
    "id": 1255098,
    "sectorId": 1254996,
    "productId": 1169603,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "EPLI"
}, {
    "id": 1255085,
    "sectorId": 1254996,
    "productId": 1169611,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Equipment Breakdown"
}, {
    "id": 1255095,
    "sectorId": 1254996,
    "productId": 1169607,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Fidelity\/Crime"
}, {
    "id": 1255083,
    "sectorId": 1254996,
    "productId": 1169604,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Fiduciary"
}, {
    "id": 1255088,
    "sectorId": 1254996,
    "productId": 1169613,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "General Liability"
}, {
    "id": 1255086,
    "sectorId": 1254996,
    "productId": 1169610,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Inland Marine"
}, {
    "id": 1255093,
    "sectorId": 1254996,
    "productId": 1169619,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Kidnap & Ransom"
}, {
    "id": 1255084,
    "sectorId": 1254996,
    "productId": 1169617,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Multinational"
}, {
    "id": 1255100,
    "sectorId": 1254996,
    "productId": 1169609,
    "value": 0,
    "sectorName": "Physician Groups",
    "productName": "Ocean Cargo"
}, {
    "id": 1255094,
    "sectorId": 1254996,
    "productId": 1169606,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Package"
}, {
    "id": 1255097,
    "sectorId": 1254996,
    "productId": 1169615,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Prof\/E&O Liability"
}, {
    "id": 1255087,
    "sectorId": 1254996,
    "productId": 1169616,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Property"
}, {
    "id": 1255090,
    "sectorId": 1254996,
    "productId": 1169618,
    "value": 4,
    "sectorName": "Physician Groups",
    "productName": "Umbrella\/Excess"
}, {
    "id": 1255092,
    "sectorId": 1254996,
    "productId": 1169612,
    "value": 1,
    "sectorName": "Physician Groups",
    "productName": "Workers Comp"
}];

export default appetites;



// WEBPACK FOOTER //
// ./src/data/appetites.js